import { produce } from "immer";
import {
  tMessageThreadsAction,
  tMessageThreadsState,
  tSetCurrentThread,
  tSetCurrentThreadId,
  tUpdateAlertMessages,
  tUpdateCurrentThread,
  tUpdateMessageDrafts,
  tUpdateMessageRecipients,
  tUpdateMessageThreads,
} from "./types";

const kDefaultMessageThreadsState: tMessageThreadsState = {
  rThreads: [],
  rCurrentThreadId: "",
  rCurrentThread: null,
  rCurrentMessages: [],
  rMessageRecipients: {},
  rAlertNewMessage: {},
  messageDrafts: {},
};

const handleUpdateMessageThreads = (
  state: tMessageThreadsState,
  action: tUpdateMessageThreads,
): tMessageThreadsState => {
  const { rCurrentThreadId: currCurrentThreadId, rCurrentThread: currCurrentThread } = state;
  const { rThreads = [] } = action;
  let rCurrentThreadId = currCurrentThreadId;
  let rCurrentThread = currCurrentThread;
  if (!currCurrentThreadId && rThreads.length > 0) {
    rCurrentThreadId = rThreads[0].id;
    rCurrentThread = rThreads[0];
  }
  state.rThreads = rThreads;
  state.rCurrentThreadId = rCurrentThreadId;
  state.rCurrentThread = rCurrentThread;
  return state;
};

const handleSetCurrentThreadId = (state: tMessageThreadsState, action: tSetCurrentThreadId): tMessageThreadsState => {
  const { rCurrentThreadId } = action;
  state.rCurrentThreadId = rCurrentThreadId;
  return state;
};

const handleUpdateCurrentThread = (state: tMessageThreadsState, action: tUpdateCurrentThread): tMessageThreadsState => {
  const { rCurrentMessages } = action;
  state.rCurrentMessages = rCurrentMessages;
  return state;
};

const handleUpdateAlertMessages = (state: tMessageThreadsState, action: tUpdateAlertMessages): tMessageThreadsState => {
  const { value, threadId } = action;
  state.rAlertNewMessage[threadId] = value;
  return state;
};

const handleSetMessageRecipients = (
  state: tMessageThreadsState,
  action: tUpdateMessageRecipients,
): tMessageThreadsState => {
  const { rMessageRecipients } = action;
  return { ...state, rMessageRecipients };
};

const handleSetMessageDrafts = (state: tMessageThreadsState, action: tUpdateMessageDrafts): tMessageThreadsState => {
  state.messageDrafts[action.payload.threadId] = action.payload.message;
  return state;
};

const handleSetCurrentThread = (state: tMessageThreadsState, action: tSetCurrentThread): tMessageThreadsState => {
  return { ...state, rCurrentThread: action.currentThread };
};

export const MessageThreadsReducer = produce(
  (state: tMessageThreadsState = kDefaultMessageThreadsState, action: tMessageThreadsAction): tMessageThreadsState => {
    switch (action.type) {
      case "UPDATE_MESSAGE_THREADS":
        return handleUpdateMessageThreads(state, action);
      case "SET_CURRENT_THREAD_ID":
        return handleSetCurrentThreadId(state, action);
      case "SET_CURRENT_THREAD":
        return handleSetCurrentThread(state, action);
      case "UPDATE_CURRENT_THREAD":
        return handleUpdateCurrentThread(state, action);
      case "UPDATE_MESSAGE_RECIPIENTS":
        return handleSetMessageRecipients(state, action);
      case "UPDATE_ALERT_MESSAGE":
        return handleUpdateAlertMessages(state, action);
      case "UPDATE_MESSAGE_DRAFT":
        return handleSetMessageDrafts(state, action);
      default:
        return state;
    }
  },
);
